import ReactDOM from 'react-dom';
// import './assets/styles/sass/index.scss';
import { routing } from './AppRouting';

// Set background color for TAZA-Taste of Health app specifically
document.getElementById('idHTML').style.backgroundColor = '#01a685';
document.body.style.backgroundColor = '#01a685';

ReactDOM.render(routing, document.getElementById('root'));
